<template>
  <div>
  <v-dialog v-model="visible" v-if="receipt" persistent width="450" content-class="tip-dialog">
    <v-form ref="paymentChangeForm" @submit.prevent="submit">
      <v-card class="glass-card-tip">
        <v-card-title class="glass-header-tip pa-0">
          <v-row class="ma-0 pa-4 align-center">
            <v-col cols="auto" class="pa-0">
              <v-icon color="white" size="28">mdi-cash-plus</v-icon>
            </v-col>
            <v-col class="pa-0 pl-3">
              <h3 class="white--text" style="font-weight: 600; font-size: 18px; letter-spacing: 0.3px;">Dodaj napojnicu</h3>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto" class="pa-0">
              <v-icon large color="white" @click="close">mdi-close</v-icon>
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="pt-4 px-4 pb-2">
          <v-row class="pt-2">
            <v-col class="pb-2 mb-0" cols="6">
              <money-input
                hide-details
                dense
                outlined
                ref="total"
                label="Iznos računa"
                disabled
                v-model="receipt.total"
                :currency="currency"
                :rules="[rules.req]"
                class="tip-input"
              ></money-input>
            </v-col>
            <v-col class="pb-2 mb-0" cols="6">
              <money-input
                hide-details
                dense
                outlined
                ref="gotMoney"
                label="Primljen iznos"
                v-model="gotMoney"
                :currency="currency"
                :rules="[rules.req]"
                @blur="setTip()"
                class="tip-input"
              ></money-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-2 mt-0 pb-2 mb-0">
              <money-input
                hide-details
                outlined
                autofocus
                ref="tipAmount"
                label="Iznos napojnice"
                v-model="tipAmount"
                :currency="currency"
                :rules="[rules.req]"
                class="tip-amount-input"
              ></money-input>
            </v-col>
          </v-row>
          <v-row class="mt-2">
            <v-col class="pb-0 mb-0">
              <div class="payment-label">Način plaćanja</div>
            </v-col>
          </v-row>
          <v-row class="payment-methods-row justify-center">
            <v-col
              v-for="(method, idx) in paymentMethods"
              :key="idx"
              cols="6"
              class="pa-2"
            >
              <v-btn
                block
                elevation="4"
                class="payment-method-btn-tip"
                :class="[
                  { 'payment-method-selected': selectedPaymentMethod === method.value },
                  method.value === 'NOVČANICE' ? 'cash-btn-tip' : 'card-btn-tip'
                ]"
                @click="selectedPaymentMethod = method.value"
              >
                <div class="btn-content-tip">
                  <v-icon size="48" class="mb-2">
                    {{ method.value === 'NOVČANICE' ? 'mdi-currency-eur' : 'mdi-credit-card-outline' }}
                  </v-icon>
                  <div class="btn-text-tip">{{ method.value === 'NOVČANICE' ? 'GOTOVINA' : 'KARTICA' }}</div>
                </div>
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-2 mt-0 pb-0 mb-0">
              <v-row class="align-center">
                <v-col cols="8">
                  <div ref="selectedSeller" v-if="selectedSeller" class="seller-info">
                    <div style="font-size: 12px; color: rgba(57, 137, 201, 0.8); font-weight: 500; letter-spacing: 0.3px;">
                      Prodavač
                    </div>
                    <div style="font-weight: 600; color: rgba(70, 70, 80, 0.9); font-size: 14px;">
                      {{
                        $options.filters.capitalize(selectedSeller.name) +
                        " " +
                        $options.filters.capitalize(selectedSeller.surname)
                      }}
                    </div>
                  </div>
                </v-col>
                <v-col cols="4" class="text-right">
                  <v-btn
                    small
                    @click="openSellers"
                    class="change-seller-btn"
                    elevation="0"
                  >
                    <v-icon small class="mr-1">mdi-account-switch</v-icon>
                    Promijeni
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="d-flex justify-center px-4 pb-4">
          <v-btn
            outlined
            color="primary"
            @click="close"
            class="cancel-btn-tip"
            elevation="0"
          >
            Odustani
          </v-btn>
          <v-btn
            @click="submit"
            class="submit-btn-tip"
            elevation="0"
          >
            Završi
          </v-btn>
        </v-card-actions>
      </v-card>
      <tip-seller
        ref="tipSeller"
        @sellerSelected="onSellerSelected"
      ></tip-seller>
    </v-form>
    <v-overlay v-if="loading" absolute z-index="10">
      <v-progress-circular
        indeterminate
        size="64"
        color="primary"
      ></v-progress-circular>
    </v-overlay>
  </v-dialog>
  <v-snackbar
    v-model="snackbar"
    :timeout="3000"
    :color="snackbarColor"
    top
    right
  >
    <v-icon left color="white">mdi-information</v-icon>
    {{ snackbarText }}
    <template v-slot:action="{ attrs }">
      <v-btn text v-bind="attrs" @click="snackbar = false" color="white">
        Zatvori
      </v-btn>
    </template>
  </v-snackbar>
  </div>
</template>
<script>
import rules from '@/plugins/rules'
import { clone } from '@/plugins/utils'
import { df, functions } from '@/plugins/firebase'
import MoneyInput from '@/components/MoneyInput'
import TipSeller from '@/modules/company/components/TipSeller'

import state from '@/state'
export default {
  inject: ['showMsgBox', 'showLoader', 'hideLoader', 'confirm', 'confirmClose'],
  components: {
    MoneyInput,
    TipSeller
  },
  data: function () {
    return {
      visible: false,
      loading: false,
      receipt: undefined,
      selectedPaymentMethod: undefined,
      tipAmount: 0,
      gotMoney: 0,
      currency: 'EUR',
      sellers: [],
      selectedSeller: undefined,
      paymentMethods: [{
        name: 'Novčanice', value: 'NOVČANICE'
      },
      {
        name: 'Kartica', value: 'KARTICA'
      }
      ],
      rules: {
        req: rules.req()
      },
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'info'
    }
  },
  computed: {

  },
  methods: {
    onSellerSelected (seller) {
      this.selectedSeller = seller
    },
    openSellers () {
      this.$refs.tipSeller.open(this.sellers)
    },
    setTip () {
      var gotMoney = parseFloat(this.$refs.gotMoney.currencyToFloat(this.gotMoney) * 100)
      var total = parseFloat(this.$refs.total.currencyToFloat(this.receipt.total) * 100)

      if (gotMoney > 0) {
        var calculation = Math.round(gotMoney - total)
        if (calculation < 0) {
          calculation = 0
        }
        this.tipAmount = calculation
        this.setMoneyField('tipAmount', this.tipAmount)
      }
    },
    setMoneyField (field, value) {
      this.$refs[field].$el.getElementsByTagName('input')[0].value = value
    },
    open (receipt) {
      if (!receipt) return
      this.visible = true
      this.receipt = clone(receipt)

      this.paymentMethods.forEach((payment) => {
        if (payment.value === this.receipt.payment_method) {
          this.selectedPaymentMethod = payment.value
        }
      })

      this.getSellers()
    },
    close () {
      this.visible = false
      this.tipAmount = 0
      this.gotMoney = 0
      this.selectedPaymentMethod = undefined
      this.receipt = undefined
    },
    async getSellers () {
      const snapshot = await df.collection(`cash_registers/${this.receipt.designation.register_id}/users`).get()
      this.sellers = []

      var sellerId = this.receipt.seller_id
      var sellerName = this.receipt.seller_name
      var sellerUid = this.receipt.seller_uid ? this.receipt.seller_uid : ''

      snapshot.forEach((doc) => {
        var seller = doc.data()
        this.sellers.push(seller.user)

        if (seller.user.name + ' ' + seller.user.surname === sellerName) {
          this.selectedSeller = seller.user
        }

        if (seller.user.designation === sellerId) {
          this.selectedSeller = seller.user
        }

        if (seller.user.name + ' ' + seller.user.surname === sellerName && seller.user.designation === sellerId) {
          this.selectedSeller = seller.user
        }

        if (seller.id === sellerUid) {
          this.selectedSeller = seller.user
        }
      })
    },
    submit () {
      if (!this.selectedPaymentMethod || this.selectedPaymentMethod === '') return
      this.loading = true
      var tips = functions.httpsCallable('tips')

      var tipAmount = Math.round(parseFloat(this.$refs.tipAmount.currencyToFloat(this.tipAmount) * 100))
      if (tipAmount <= 0) {
        this.loading = false
        this.showMsgBox({ text: 'Iznos napojnice je 0. Molimo unesite iznos napojnice.', actions: ['cancel'], cancelBtnText: 'OK', color: 'ok' })
        return
      }

      const params = {
        company_id: state.getCurrentCompany().id,
        tip_payment_method: this.selectedPaymentMethod,
        receipt_id: this.receipt.id,
        tip_amount: Math.round(parseFloat(this.$refs.tipAmount.currencyToFloat(this.tipAmount) * 100)),
        override: false
      }

      params.seller_id = ''
      if (this.selectedSeller && this.selectedSeller.id !== '') {
        params.seller_id = this.selectedSeller.id
      }

      tips(
        params
      )
        .then((result) => {
          if (result.data.code === 200) {
            this.loading = false
            this.snackbarText = 'Uspješno spremljena napojnica.'
            this.snackbarColor = 'info'
            this.snackbar = true
            this.close()
          } else {
            if (result.data.code === 403) {
              this.loading = false
              this.confirm({
                title: 'Napojnica već postoji',
                message: result.data.message,
                options: {
                  toolbar: true,
                  width: 410,
                  confirmText: 'Nastavi',
                  cancelText: 'Odustani'
                }
              }).then(async (resp) => {
                if (resp) {
                  this.loading = true
                  params.override = true
                  tips(
                    params
                  )
                    .then((result) => {
                      this.confirmClose()
                      this.loading = false
                      this.snackbarText = 'Uspješno spremljena napojnica.'
                      this.snackbarColor = 'info'
                      this.snackbar = true
                      this.close()
                    })
                } else {
                  this.confirmClose()
                  this.loading = false
                  this.close()
                }
              })
            } else {
              this.loading = false
              const errorMessage = result.data.message || result.data.error || 'Greška prilikom dodavanja napojnice.'
              this.showMsgBox({
                title: 'Greška',
                text: errorMessage,
                actions: ['cancel'],
                cancelBtnText: 'OK',
                color: 'error'
              })
            }
          }
        })
    }
  }
}
</script>

<style scoped>
/* Glass Card with Brand Gradient Header */
.glass-card-tip {
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
  border-radius: 16px !important;
  border: 1px solid rgba(0, 179, 190, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 179, 190, 0.15) !important;
  overflow: hidden;
}

.glass-header-tip {
  background: linear-gradient(135deg,
    rgba(0, 179, 190, 0.9) 0%,
    rgba(57, 137, 201, 0.85) 50%,
    rgba(97, 84, 164, 0.9) 100%) !important;
  position: relative;
}

/* Input Fields Styling */
.tip-input >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 8px !important;
}

.tip-input >>> fieldset {
  border-color: rgba(57, 137, 201, 0.2) !important;
  border-radius: 8px !important;
}

.tip-input >>> .v-input--is-focused fieldset {
  border-color: #3989C9 !important;
  border-width: 2px !important;
}

.tip-input >>> .v-input--is-disabled .v-input__slot {
  background: rgba(245, 245, 245, 0.8) !important;
}

.tip-input >>> label {
  font-size: 13px !important;
  font-weight: 500 !important;
  color: rgba(57, 137, 201, 0.8) !important;
  letter-spacing: 0.3px !important;
}

.tip-input >>> input {
  font-size: 14px !important;
  font-weight: 500 !important;
  color: rgba(70, 70, 80, 0.9) !important;
}

/* Tip Amount Input - Larger */
.tip-amount-input >>> .v-input__slot {
  background: rgba(255, 255, 255, 0.9) !important;
  backdrop-filter: blur(10px) !important;
  border-radius: 12px !important;
  min-height: 64px !important;
}

.tip-amount-input >>> fieldset {
  border-color: rgba(76, 175, 80, 0.3) !important;
  border-radius: 12px !important;
  border-width: 2px !important;
}

.tip-amount-input >>> .v-input--is-focused fieldset {
  border-color: rgba(76, 175, 80, 0.8) !important;
  border-width: 3px !important;
}

.tip-amount-input >>> label {
  font-size: 15px !important;
  font-weight: 600 !important;
  color: rgba(76, 175, 80, 0.8) !important;
  letter-spacing: 0.3px !important;
}

.tip-amount-input >>> input {
  font-size: 24px !important;
  font-weight: 700 !important;
  color: rgba(76, 175, 80, 0.9) !important;
  letter-spacing: 0.5px !important;
}

/* Payment Methods Section */
.payment-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(57, 137, 201, 0.8);
  letter-spacing: 0.3px;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.payment-methods-row {
  margin-top: 4px;
}

/* Payment Method Buttons - Matching PaymentMethodDialog */
.payment-method-btn-tip {
  border-radius: 16px !important;
  border: 2px solid rgba(255, 255, 255, 0.4) !important;
  backdrop-filter: blur(10px) !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
  text-transform: none !important;
  padding: 24px 16px !important;
  min-height: 180px !important;
  position: relative;
}

.btn-content-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.btn-text-tip {
  font-size: 18px !important;
  font-weight: 700 !important;
  letter-spacing: 1px !important;
  color: white !important;
}

/* Cash Button (Blue) */
.cash-btn-tip {
  background: linear-gradient(135deg,
    rgba(44, 90, 144, 0.95) 0%,
    rgba(33, 67, 108, 0.9) 100%) !important;
  box-shadow: 0 8px 24px rgba(44, 90, 144, 0.4) !important;
}

.cash-btn-tip:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(44, 90, 144, 1) 0%,
    rgba(33, 67, 108, 1) 100%) !important;
  box-shadow: 0 12px 32px rgba(44, 90, 144, 0.6) !important;
  transform: translateY(-8px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.6) !important;
}

/* Card Button (Cyan) */
.card-btn-tip {
  background: linear-gradient(135deg,
    rgba(59, 120, 195, 0.95) 0%,
    rgba(41, 91, 144, 0.9) 100%) !important;
  box-shadow: 0 8px 24px rgba(59, 120, 195, 0.4) !important;
}

.card-btn-tip:hover:not(:disabled) {
  background: linear-gradient(135deg,
    rgba(59, 120, 195, 1) 0%,
    rgba(41, 91, 144, 1) 100%) !important;
  box-shadow: 0 12px 32px rgba(59, 120, 195, 0.6) !important;
  transform: translateY(-8px) scale(1.05);
  border-color: rgba(255, 255, 255, 0.6) !important;
}

.payment-method-btn-tip .v-icon {
  color: white !important;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.payment-method-btn-tip:hover .v-icon {
  transform: scale(1.1);
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.4));
}

/* Selected State */
.payment-method-selected {
  transform: translateY(-4px) scale(1.02) !important;
  border-width: 3px !important;
  border-color: rgba(255, 255, 255, 0.8) !important;
}

.cash-btn-tip.payment-method-selected {
  box-shadow: 0 12px 32px rgba(44, 90, 144, 0.7),
              0 0 0 4px rgba(44, 90, 144, 0.2) !important;
}

.card-btn-tip.payment-method-selected {
  box-shadow: 0 12px 32px rgba(59, 120, 195, 0.7),
              0 0 0 4px rgba(59, 120, 195, 0.2) !important;
}

.payment-method-selected .v-icon {
  transform: scale(1.15) !important;
  filter: drop-shadow(0 6px 12px rgba(0, 0, 0, 0.5)) !important;
}

.payment-method-selected .btn-text-tip {
  transform: scale(1.05);
}

/* Seller Info Section */
.seller-info {
  padding: 8px 12px;
  background: rgba(57, 137, 201, 0.05) !important;
  border-radius: 8px;
  border: 1px solid rgba(57, 137, 201, 0.15);
}

/* Change Seller Button */
.change-seller-btn {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 8px !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 500 !important;
  font-size: 13px !important;
  letter-spacing: 0.3px !important;
  transition: all 0.2s ease !important;
}

.change-seller-btn:hover {
  background: rgba(255, 255, 255, 1) !important;
  border-color: #3989C9 !important;
  box-shadow: 0 2px 6px rgba(57, 137, 201, 0.2) !important;
  transform: translateY(-1px);
}

.change-seller-btn .v-icon {
  color: #3989C9 !important;
}

/* Cancel Button */
.cancel-btn-tip {
  background: rgba(255, 255, 255, 0.9) !important;
  color: #3989C9 !important;
  border: 1px solid rgba(57, 137, 201, 0.25) !important;
  border-radius: 12px !important;
  box-shadow: 0 2px 8px rgba(57, 137, 201, 0.12) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.cancel-btn-tip:hover {
  background: rgba(255, 255, 255, 1) !important;
  border-color: #3989C9 !important;
  box-shadow: 0 4px 12px rgba(57, 137, 201, 0.25) !important;
  transform: translateY(-1px);
}

/* Submit Button */
.submit-btn-tip {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 0.95) 0%,
    rgba(56, 142, 60, 0.9) 100%) !important;
  color: white !important;
  border-radius: 12px !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25) !important;
  backdrop-filter: blur(10px) !important;
  text-transform: none !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  letter-spacing: 0.3px !important;
  padding: 10px 24px !important;
  height: 40px !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.submit-btn-tip:hover {
  background: linear-gradient(135deg,
    rgba(76, 175, 80, 1) 0%,
    rgba(56, 142, 60, 1) 100%) !important;
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 8px 20px rgba(76, 175, 80, 0.4) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
}

/* Dialog Border Radius */
.tip-dialog {
  border-radius: 16px !important;
}
</style>
